
import { Dialog, DialogContent, TextField } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import ComboBox from "components/ComboBox"
import PaperComponent from "components/PaperComponent"
import { DialogFooter, DialogHeader } from "components/dialog/DialogHeader"
import { GlobalStateContext } from "contexts/GlobalStateContext"
import React, { useCallback, useContext, useEffect, useState } from "react"
import { initOilChangeDialogData } from "./initData"
import { oilChangeApiNm, oilChangeColNm } from "./constant"
import { alertConfirmDelete } from "components/Alert"
import { bahtProps } from "utils/bahtProps"
import { DesktopDatePicker } from "@mui/x-date-pickers-pro"
import dayjs from "dayjs"
import FilePreviewCard from "components/FileUplaod/FilePreviewCard"

const OilChangeDialog = ({ selectedId, dialogOpen, setDialogOpen, onFinish, sparePartCombo }) => {

  const { ax, msData } = useContext(GlobalStateContext)
  const [dialogData, setDialogData] = useState({ ...initOilChangeDialogData })
  const [origData, setOrigData] = useState({ ...initOilChangeDialogData })
  const [filesData, setFilesData] = useState([])
  const [pendingFiles, setPendingFiles] = useState([])

  const dialogDataProp = useCallback((name) => ({
    fullWidth: true,
    size: "small",
    label: oilChangeColNm[name],
    value: dialogData[name] ?? "",
    onChange: (e) => setDialogData(o => ({ ...o, [name]: e.target.value })),
  }), [dialogData])

  const uploadFiles = useCallback(async (oilChgId) => {
    for (const pf of pendingFiles) {
      const formData = new FormData()
      formData.append('file', pf.file)
      formData.append('SpTrnsId', oilChgId)
      formData.append('Label', pf.name)
      await ax.post(oilChangeApiNm.uploadOilChangeFile, formData)
    }
    setPendingFiles([])
  }, [ax, pendingFiles])

  const handleDialogOk = useCallback(async () => {
    if (selectedId) {
      const colValues = {}
      for (const key of ['TukId', 'ChgDte', 'Mileage', 'MileageIntv', 'DteIntv', 'Dscp', 'Rmk']) {
        if (String(dialogData[key] ?? '') !== String(origData[key] ?? '')) {
          colValues[key] = dialogData[key]
        }
      }
      const hasChange = Object.keys(colValues).length > 0
      const hasNewFiles = pendingFiles.length > 0
      if (hasChange) {
        await ax.post(oilChangeApiNm.updateOilChangeColumn, {
          SpTrnsId: selectedId,
          ColValues: colValues,
        })
      }
      if (hasNewFiles) {
        await uploadFiles(selectedId)
      }
      if (hasChange || hasNewFiles) {
        onFinish()
      }
      setDialogOpen(false)
    } else {
      const postData = { ...dialogData }
      const value = await ax.post(oilChangeApiNm.insertOilChange, postData)
      if (value.data) {
        const oilChgId = value.data
        if (oilChgId && pendingFiles.length > 0) {
          await uploadFiles(oilChgId)
        }
        onFinish()
        setDialogOpen(false)
      }
    }
  }, [ax, dialogData, origData, onFinish, setDialogOpen, selectedId, pendingFiles, uploadFiles])

  const handleDelete = useCallback(() => {
    alertConfirmDelete(() => {
      ax.post(oilChangeApiNm.deleteOilChange, { SpTrnsId: selectedId }).then(value => {
        if (value.data) {
          onFinish()
          setDialogOpen(false)
        }
      })
    })
  }, [ax, onFinish, selectedId, setDialogOpen])

  const handleDeleteServerFile = useCallback((file) => {
    return new Promise((resolve) => {
      alertConfirmDelete(() => {
        ax.post(oilChangeApiNm.deleteOilChangeFile, { OilChgFileId: file.OilChgFileId }).then(value => {
          if (value.data) {
            resolve()
          }
        })
      })
    })
  }, [ax])

  // Auto-calculate TotalPr
  useEffect(() => {
    const total = (+dialogData.Qty || 0) * (+dialogData.UntPr || 0)
    setDialogData(o => {
      if (o.TotalPr === total) return o
      return { ...o, TotalPr: total }
    })
  }, [dialogData.Qty, dialogData.UntPr])

  // Auto-calculate NxtMileage
  useEffect(() => {
    if (dialogData.Mileage && dialogData.MileageIntv) {
      const nxt = (+dialogData.Mileage) + (+dialogData.MileageIntv)
      setDialogData(o => {
        if (o.NxtMileage === nxt) return o
        return { ...o, NxtMileage: nxt }
      })
    }
  }, [dialogData.Mileage, dialogData.MileageIntv])

  // Auto-calculate NxtDte
  useEffect(() => {
    if (dialogData.ChgDte && dialogData.DteIntv) {
      const nxt = dayjs(dialogData.ChgDte).add(+dialogData.DteIntv, 'day').format("YYYY-MM-DD")
      setDialogData(o => {
        if (o.NxtDte === nxt) return o
        return { ...o, NxtDte: nxt }
      })
    }
  }, [dialogData.ChgDte, dialogData.DteIntv])

  useEffect(() => {
    if (dialogOpen) {
      if (selectedId) {
        ax.post(oilChangeApiNm.getOilChangeDetail, { SpTrnsId: selectedId }).then(value => {
          if (value.data && value.data.length > 0) {
            setDialogData(value.data[0])
            setOrigData(value.data[0])
            setFilesData(value.data[0].Files || [])
          }
        })
      } else {
        setFilesData([])
      }
    } else {
      setDialogData({ ...initOilChangeDialogData })
      setOrigData({ ...initOilChangeDialogData })
      setFilesData([])
      setPendingFiles(o => {
        o.forEach(f => URL.revokeObjectURL(f.preview))
        return []
      })
    }
  }, [dialogOpen, ax, selectedId])

  console.log("spare part combo:", sparePartCombo )
  return (
    <Dialog
      open={dialogOpen}
      onClose={(e, reason) => {
        if (reason === "backdropClick") return
        setDialogOpen(false)
      }}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='xs'
    >
      <DialogHeader handleDialogClose={() => setDialogOpen(false)}
        title="รายการเปลี่ยนถ่ายน้ำมัน"
        onDeleteClick={selectedId ? handleDelete : null}
      />
      <DialogContent>
        <BoxFC pt={2} sx={{ gap: 1 }}>
          <BoxFR>
            <DesktopDatePicker
              label={oilChangeColNm.ChgDte}
              inputFormat="DD/MM/YYYY"
              value={dialogData.ChgDte}
              onChange={(v) => setDialogData(o => ({ ...o, ChgDte: v ? dayjs(v).format("YYYY-MM-DD") : null }))}
              renderInput={(params) => <TextField size="small" fullWidth {...params} />}
            />
            <ComboBox
              sx={{ width: "100%" }}
              options={sparePartCombo || []}
              label={oilChangeColNm.SpId}
              selectedId={dialogData.SpId}
              setSelectedId={(id) => {
                const found = sparePartCombo?.find(s => s.id === id)
                setDialogData(o => ({ ...o, SpId: id, UntPr: found?.UntPr || 0 }))
              }}
              disabled={!!selectedId}
            />
          </BoxFR>
          <BoxFR>
            <ComboBox
              sx={{ width: "100%" }}
              options={msData.truckCombo || []}
              label={oilChangeColNm.TukId}
              selectedId={dialogData.TukId}
              setSelectedId={(id) => setDialogData(o => ({ ...o, TukId: id }))}
              required
            />
            <TextField {...dialogDataProp('Mileage')} type="number" />
          </BoxFR>

          <BoxFR sx={{ gap: 1 }}>
            <TextField {...dialogDataProp('Qty')} type="number" disabled={!!selectedId} />
            <TextField {...dialogDataProp('UntPr')} type="number" {...bahtProps} disabled={!!selectedId} />
          </BoxFR>
          {/* <TextField {...dialogDataProp('TotalPr')} type="number" {...bahtProps} disabled /> */}
          <BoxFR sx={{ gap: 1 }}>
            <TextField {...dialogDataProp('MileageIntv')} type="number" />
            <TextField {...dialogDataProp('DteIntv')} type="number" />
          </BoxFR>
          <BoxFR sx={{ gap: 1 }}>
            <TextField {...dialogDataProp('NxtMileage')} type="number" disabled />
            <DesktopDatePicker
              label={oilChangeColNm.NxtDte}
              inputFormat="DD/MM/YYYY"
              value={dialogData.NxtDte}
              onChange={() => {}}
              disabled
              renderInput={(params) => <TextField size="small" fullWidth {...params} disabled />}
            />
          </BoxFR>
          {/* <ComboBox
            options={msData.supplierCombo || []}
            label={oilChangeColNm.SupId}
            selectedId={dialogData.SupId}
            setSelectedId={(id) => setDialogData(o => ({ ...o, SupId: id }))}
          /> */}
          <BoxFR sx={{ gap: 1 }}>
            <TextField {...dialogDataProp('DocNo')} />
            <DesktopDatePicker
              label={oilChangeColNm.DocDte}
              inputFormat="DD/MM/YYYY"
              value={dialogData.DocDte}
              onChange={(v) => setDialogData(o => ({ ...o, DocDte: v ? dayjs(v).format("YYYY-MM-DD") : null }))}
              renderInput={(params) => <TextField size="small" fullWidth {...params} />}
            />
          </BoxFR>
          <TextField {...dialogDataProp('Dscp')} multiline rows={2} />
          <TextField {...dialogDataProp('Rmk')} />
          <FilePreviewCard
            filesData={filesData}
            setFilesData={setFilesData}
            pendingFiles={pendingFiles}
            setPendingFiles={setPendingFiles}
            onDeleteServerFile={handleDeleteServerFile}
            fileIdKey="OilChgFileId"
          />
        </BoxFC>
      </DialogContent>
      <DialogFooter okText="บันทึก"
        handleDialogClose={() => setDialogOpen(false)}
        handleDialogOk={handleDialogOk} />
    </Dialog>
  )
}

export default React.memo(OilChangeDialog)
